import { render, staticRenderFns } from "./DialogOrder.vue?vue&type=template&id=6f512e68&scoped=true&lang=pug"
import script from "./DialogOrder.vue?vue&type=script&lang=js"
export * from "./DialogOrder.vue?vue&type=script&lang=js"
import style0 from "./DialogOrder.vue?vue&type=style&index=0&id=6f512e68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f512e68",
  null
  
)

export default component.exports